﻿(function() {
    "use strict";

    angular.module("app").controller("TicketsController", TicketsController);

    TicketsController.$inject = ["constants"];

    function TicketsController(constants) {
        var vm = this

        vm.constants = constants;

        vm.$onInit = onInit;

        function onInit() {
            vm.deleted = location.hash.indexOf('/deleted') > -1
        }
    }
})();
